import React from 'react';
import liff from "@line/liff"
import logo from './logo.svg';
import './App.css';
import * as Constants from './modules/Constants'

function App() {
  const isInit = React.useRef(false)
  React.useEffect(() => {
    if (!isInit.current) {
      isInit.current = true
      document.title = "アプリとLINEの連携"
      liff
        .init({
          liffId: Constants.LIFF_ID
        })
        .then(() => {
          console.log("LIFF init succeeded.")
        })
        .catch((e: Error) => {
          console.error("LIFF init failed.")
          console.error(`${e}`)
        })
    }
  }, [])
  return (
    <div className="App">
      <form name="form1">
        <div className='header'>
          <img src="logo_w.svg" className="logo_w" alt="logo" />
        </div>
        <p className="main_text">アプリとLINEを連携して<br/>おトク情報GET！</p>
        <img src="icon_wxl.png" className="icon_wxl" alt="icon_wxl" />
        <p className="sub_text">ウエルシアグループのアプリやLINE公式アカウントから、<b>メンバー限定のおトクな情報やクーポンが届くようになります。お見逃しなく！</b></p>
        <div className='box'>
          <p>＜連携方法＞</p>
          <table>
            <tr>
              <td>■STEP 1</td>
              <td>下部の「アプリとLINEを連携」ボタンをタップ</td>
            </tr>
            <tr>
              <td>■STEP 2</td>
              <td>ウエルシアグループアプリ起動<br/>※以降のSTEPはアプリ内の手順となります</td>
            </tr>
            <tr>
              <td>■STEP 3</td>
              <td>アプリ内画面より「アプリとLINEを連携」ボタンをタップ</td>
            </tr>
            <tr>
              <td>■STEP 4</td>
              <td>LINEの認可画面より、注意事項をご確認のうえ同意する<br/>※初回のみ</td>
            </tr>
            <tr>
              <td>■STEP 5</td>
              <td>規約画面より、規約内容をご確認のうえ同意する</td>
            </tr>
            <tr>
              <td>■STEP 6</td>
              <td>連携完了！</td>
            </tr>
          </table>
        </div>
        <a href={Constants.UNIVERSAL_LINK_URL}>
          <img src="btn.svg" className='btn' alt="btn" />
        </a>
        <p className="sub_text_small">
          ※1 アプリとLINEを連携するとブロックは解除されます​<br/>
          ※2 アプリとLINEの連携解除については「アプリとLINEを連携」ボタンから遷移先のアプリ内で解除可能です。<br/>
          ※3 LINEアプリ内の「連動アプリ」で本連携を解除しても、アプリとLINEの連携は維持されます。連携を解除する場合は※2に従いアプリ内で解除してください。​
        </p>
      </form>
    </div>
  )
}


export default App;
